import { Checkbox } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import { Filter } from "../../../types";

export interface AddFilterProps {
  filters: Filter[];
  setFilters: Dispatch<SetStateAction<Filter[]>>;
}

export const AddFilter: FC<AddFilterProps> = ({ filters, setFilters }) => {
  const handleAddFilter = (filter: Filter) => {
    setFilters((prev) => [...prev, filter]);
  };

  const handleRemoveFilter = (filter: Filter) => {
    setFilters((prev) =>
      prev.filter((f) => f.class + f.name !== filter.class + filter.name)
    );
  };

  const handleAvailableChange = (checked?: boolean) => {
    if (checked) {
      handleAddFilter({
        class: "availability",
        value: true,
        name: "Available",
      });
    } else {
      handleRemoveFilter({
        class: "availability",
        value: true,
        name: "Available",
      });
    }
  };

  const handleHasConflictsChange = (checked?: boolean) => {
    if (checked) {
      handleAddFilter({
        class: "availability",
        value: false,
        name: "Has Conflicts",
      });
    } else {
      handleRemoveFilter({
        class: "availability",
        value: false,
        name: "Has Conflicts",
      });
    }
  };

  const handleLevelChange = (filter: Filter, checked?: boolean) => {
    return checked ? handleAddFilter(filter) : handleRemoveFilter(filter);
  };

  return (
    <div className='p-8 w-96'>
      <h3 className='text-primary-500 font-semibold'>Filters</h3>
      <div className='mt-8'>
        <div className='mt-4'>
          <h5 className='text-primary-500 text-lg font-semibold'>
            Availability
          </h5>
          <div className='grid grid-cols-1 gap-y-2'>
            <Checkbox
              checked={filters.some((filter) => {
                return filter.class === "availability" && filter.value;
              })}
              onChange={({ target: { checked } }) =>
                handleAvailableChange(checked)
              }
            >
              Available
            </Checkbox>
            <Checkbox
              className='!ml-0'
              checked={filters.some((filter) => {
                return filter.class === "availability" && !filter.value;
              })}
              onChange={({ target: { checked } }) =>
                handleHasConflictsChange(checked)
              }
            >
              Has Conflicts
            </Checkbox>
          </div>
        </div>
      </div>
    </div>
  );
};
